import React, { useState, useEffect } from "react";
import Loading from "../../shared/loading";
import { useAuthContext } from "../../context/authContext";
import { isAdmin } from "../../helpers/role";
import { Button } from "../../shared/button";
import {
  Chat,
  ChatMemebr,
  ChatMessage,
  ChatService,
} from "../../APIService/ChatService";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { Settings } from "@mui/icons-material";

export function OneChatSettings() {
  const { enqueueSnackbar } = useSnackbar();
  const [members, setMembers] = useState<ChatMemebr[]>([]);
  const [loading, setLoading] = useState(true);
  const { authInfo } = useAuthContext();
  const chatId = Number(useParams().id);
  const [update, setUpdate] = useState(false);
  const [chatName, setChatName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    ChatService.getChatInfo(chatId)
      .then((chat) => {
        setChatName(chat.name);
        ChatService.getChatMembers(chatId)
          .then((data) => {
            setMembers(data);
            setLoading(false);
          })
          .catch(() => {
            enqueueSnackbar(`Упс!`, {
              variant: "error",
              anchorOrigin: { horizontal: "right", vertical: "top" },
            });
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar(`Чат не найден`, {
          variant: "error",
          anchorOrigin: { horizontal: "right", vertical: "top" },
        });
        setLoading(false);
      });
  }, [update]);

  return (
    <div className="Wrapper">
      <div className="chatPage">
        <h3>
          {chatName} <Settings />
        </h3>
        {loading ? (
          <Loading />
        ) : members.length > 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              padding: 20,
            }}
          >
            {members.map((m) => {
              // format m.date to day.month hh:mm
              return (
                <div key={m.id}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "10% 90%",
                      gap: "1rem",
                    }}
                  >
                    <span>ID_{m.id}</span> <span>{m.sysName}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p>Нет пользователей</p>
        )}
        <Formik
          initialValues={{ userId: "" }}
          validationSchema={Yup.object({
            userId: Yup.string().required("Обязательное поле"),
          })}
          onSubmit={async (
            values: { userId: string },
            actions: FormikHelpers<{ userId: string }>,
          ) => {
            console.log({ values, actions });
            await ChatService.addChatMembers(chatId, Number(values.userId));
            actions.resetForm();
            setUpdate(!update);
          }}
        >
          {({ isSubmitting }) => (
            <Form className="EditFormSelfPayment">
              <Field id="userId" type="text" name="userId" />
              <button
                className={"SharedButton"}
                type="submit"
                disabled={isSubmitting}
              >
                Добавить пользователя
              </button>
            </Form>
          )}
        </Formik>
        <br />
        <button
          className={"SharedButton"}
          onClick={async () => {
            if (isAdmin(authInfo.role)) {
              if (
                !window.confirm(
                  "Вы уверены, что хотите удалить чат и историю переписки?",
                )
              ) {
                return;
              }
              await ChatService.deleteChat(chatId);
              enqueueSnackbar(`Чат удален`, {
                variant: "success",
                anchorOrigin: { horizontal: "right", vertical: "top" },
              });
              navigate("/lk");
            }
          }}
        >
          Удалить чат
        </button>
      </div>
    </div>
  );
}

export default OneChatSettings;
